import Joi from "joi-browser";

const EmailSchema = Joi.object().keys({
    email: Joi.string()
        .regex(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        .required()
        .label("Email")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "any.empty":
                        return "can't be an empty field.";
                    case "string.regex.base":
                        return "should be somthing like this: example@abc.com";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
});

const NameSchema = Joi.object().keys({
    name: Joi.string()
        .trim()
        .required()
        .label("Name")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: "is required",
                },
            };
        }),
});

const StrictNameSchema = Joi.object().keys({
    name: Joi.string()
        .regex(/[/?&=#+:@]/, { invert: true })
        .trim()
        .max(125)
        .min(2)
        .required()
        .label("Name")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                if (err.type === "string.regex.invert.base") {
                    return "is invalid";
                }
                if (err.type === "string.min") {
                    return "length must be at least 2 characters long.";
                }
                if (err.type === "string.max") {
                    return "length must be less than or equal to 20 characters long";
                } else return "is required";
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
});

export default {
    NameSchema,
    EmailSchema,
    StrictNameSchema,
};
